import { env } from '../env';

interface PredictionResponse<T> {
  json: T;
  chatMessageId: string;
  chatId: string;
  question: string;
  sessionId: string;
}

export const api = {
  makePrediction: async <T extends unknown>(prompt: string, context: string, zodFormat: string): Promise<T> => {
    const url = 'https://flowise.nanogiants.de/api/v1/prediction/d86e846f-8c1b-46b1-936c-5207a8b88d8f';

    const data = {
      question: context,
      overrideConfig: {
        template: `${prompt}. Here are context information: {context}`,
        promptValues: {
          context: '{{question}}',
        },
        exampleJson: zodFormat,
      },
    };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${env.FLOWISE_TOKEN}`,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const result = (await response.json()) as PredictionResponse<T>;
      return result.json;
    } catch (error) {
      console.error('There was a problem with your fetch operation');
      throw error;
    }
  },
};
